<template>
  <div class="news-course-detail">
        <!-- <newsHeader :page="'优秀课程'"></newsHeader> -->
        <!-- <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/news' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news/headlines' }">优秀课程</el-breadcrumb-item>
            <el-breadcrumb-item>课程详情</el-breadcrumb-item>
        </el-breadcrumb> -->
        <breadCrumb></breadCrumb>
        <div class="news-course-detail-wrapper main">
            <div class="course-detail-top flex-align">
                <img src="" alt="" class="cover">
                <div class="course-basic-info flex-between">
                    <div class="basic-info-left flex-column">
                        <div><h4 class="f20 color-black">趣味数学</h4><span>学时：99</span></div>
                        <span class="f12 color-grey">课程类型：教研</span>
                        <span class="f12 color-grey last-span">所属学校：<i class="color-basic">首都师范大学</i></span>
                    </div>
                    <div class="basic-info-right flex-layout">
                        <div class="good">
                            <img src="../../../../static/news/icon@2x.png" alt="">
                            <p class="f12 color-grey">325</p>
                        </div>
                        <div class="eye">
                            <img src="../../../../static/news/ai-eye@2x.png" alt="">
                            <p class="f12 color-grey">1537</p>
                        </div>
                    </div>
                </div>
                <div class="course-lecturer flex-column-center">
                    <h4>蔡可</h4>
                    <span class="f12 color-black">主讲教师</span>
                    <button>
                        <!-- 加入课程 -->
                    </button>
                    <span class="f12 color-grey">已有21人加入学习</span>
                </div>
            </div>
            <div class="course-detail-bottom flex-between">
                <div class="side-navbar">
                    <div class="title f20">趣味数学</div>
                    <ul >
                        <li v-for="(li, index) in navbarList" 
                            :key="index"
                            :class="{'active':isActive===index}" 
                            @click="isActive = index">
                             <a href="javascript:;" @click="isActive=index"><i></i>{{li}}</a>
                        </li>
                    </ul>
                </div>
                
                <div class="course-directory" v-show="isActive === 0">
                    <div class="course-teacher-introduce">
                        <h4 class="f20">授课教师</h4>
                        <div class="box flex-layout">
                            <img src="" alt="">
                            <div class="box-in">
                                <h5 class="f20 color-black">蔡可</h5>
                                <p>首都师范大学人工智能教育研究院常务副院长、教育部高中语文课程校准修订组核心成员，统编语文教材编写组成员、教育“国培”专家库成员。</p>
                            </div>
                        </div>
                    </div>
                    <ul>
                        <li class="flex-align-between">
                            <h4 class="f16 color-black">【第1节】基本乘法</h4>
                            <!-- <button></button> -->
                        </li>
                        <li class="flex-align-between">
                            <h4 class="f16 color-black">【第2节】基本乘法</h4>
                            <!-- <button></button> -->
                        </li>
                        <li class="flex-align-between">
                            <h4 class="f16 color-black">【第3节】基本乘法</h4>
                            <!-- <button></button> -->
                        </li>
                    </ul>
                </div>
                <div class="course-introduce" v-show="isActive === 1">
                    <div class="course-teacher-introduce">
                        <h4 class="f20">授课教师</h4>
                        <div class="box flex-layout">
                            <img src="" alt="">
                            <div class="box-in">
                                <h5 class="f20 color-black">蔡可</h5>
                                <p>首都师范大学人工智能教育研究院常务副院长、教育部高中语文课程校准修订组核心成员，统编语文教材编写组成员、教育“国培”专家库成员。</p>
                            </div>
                        </div>
                    </div>
                    <div class="course-introduce-content">
                        <ul class="course-content-list">
                            <li>
                                <h4>课程简介</h4>
                                <p class="color-black">展示数学的神奇智慧和艺术般的魅力，激发学生的数学兴趣和探索求知的欲望，在不知不觉中将学生引入奇妙的数学世界之中。人人学有价值的数学，人人都能获得必需的数学，不同的人在数学上得到不同的发展。</p>
                            </li>
                            <li>
                                <h4>课程简介</h4>
                                <p class="color-black">展示数学的神奇智慧和艺术般的魅力，激发学生的数学兴趣和探索求知的欲望，在不知不觉中将学生引入奇妙的数学世界之中。人人学有价值的数学，人人都能获得必需的数学，不同的人在数学上得到不同的发展。</p>
                            </li>
                        </ul>
                    </div>
                </div>            
            </div>
        </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            isActive:0,
            navbarList:['课程目录','课程简介']
        }
    }
}
</script>

<style lang="less">
    @import "../less/news_course_detail.less";
</style>